import React, { useEffect, useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
	arrow3,
} from "../../constant";
import HomeContactForm from "../../Components/Forms/HomeContactForm";
import { GetAboutUs, GetGalleryImage, GetNewsList, GetPlantsApi, PostNewsLetter } from "../../network/Network";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

function Aboutus() {
	const navigate = useNavigate()
	const ImageUrlRedux = useSelector((state) => state?.AuthReducer?.urlData);
	const [aboutUs, setAboutUs] = useState(null);
	const [loading, setLoading] = useState(false);
	const [newsList, setNewsList] = useState(null);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	useEffect(() => {
		setLoading(true);
		GetAboutUs()
			.then((res) => {
				setLoading(false);
				setAboutUs(res.data);
			})
			.catch((err) => {
				setLoading(false);
			})
	}, []);

	useEffect(() => {
		setLoading(true);
		GetNewsList()
			.then((res) => {
				setLoading(false);
				setNewsList(res.data);
			})
			.catch((err) => {
				setLoading(false);
			})
	}, []);

	return (
		<>
			<Header />
			<MainBanner name={"About us"} />
			<section className="about-page">
				<div className="container">
					{loading
						?
						<Skeleton count={15} />
						:
						<div className="row">
							<div className="col-lg-3">
								<div className="img-cont">
									<img src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[0]}`} alt="" />
								</div>
								<div className="img-cont">
									<img src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[1]}`} alt="" />
								</div>
							</div>
							<div className="col-lg-6">
								<h2 className="main-Title">{aboutUs?.title}</h2>
								<p className="main-para">
									{aboutUs?.description}
								</p>
								<div className="btn-container mt-4 mb-5">
									<button className="btn BOOKNOW"
										onClick={(e) => navigate("/camping")}
									>
										BOOK NOW <img src={arrow3} alt="" />{" "}
									</button>
								</div>
							</div>
							<div className="col-lg-3">
								<div className="img-cont">
									<img src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[2]}`} alt="" />
								</div>
								<div className="img-cont">
									<img src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[4]}`} alt="" />
								</div>
							</div>
						</div>
					}
				</div>

				<section className="about-pageSec2">
					<div className="container">
						{loading
							?
							<Skeleton count={10} />
							:
							<>
								{newsList?.map((item, index) => {
									if (index % 2 === 0) {
										return (
											<div className="row">
												<div className="col-lg-5">
													<div className="img-cont h-100">
														<img
															src={`${ImageUrlRedux?.hoho_newslist_url}/${item?.image}`}
															alt=""
														/>
													</div>
												</div>
												<div className="col-lg-7 pl-4">
													<div className="set_para_home">
														<h2 className="shadow-title mb-3">{item?.sub_title}</h2>
														<h3 className="main-title">{item?.title} </h3>
														<p className="para">
															{item?.description}
														</p>
													</div>
												</div>
											</div>
										)
									} else {
										return (
											<div className="row">
												<div className="col-lg-7">
													<div className="set_para_home">
														<h2 className="shadow-title">{item?.sub_title}</h2>
														<h3 className="main-title">{item?.title} </h3>
														<p className="para">
															{item?.description}
														</p>
													</div>
												</div>
												<div className="col-lg-5">
													<div className="img-cont h-100">
														<img
															src={`${ImageUrlRedux?.hoho_newslist_url}/${item?.image}`}
															alt=""
														/>

													</div>
												</div>
											</div>
										)
									}
								})}
							</>
						}
					</div>
				</section>
				<HomeContactForm />
			</section>

			<Footer />
		</>
	);
}

export default Aboutus;
